export default function getImageThumbnail(file: File) {
	return new Promise((resolve, reject) => {
		try {
			const url = URL.createObjectURL(file);
			const imageEl = document.createElement('img');
			
			// When imageE1.onload fail's , it will trigger onerror f(x)
			imageEl.onerror = () => {
				resolve(false);
			}
			
			//step down images in the canvas to reduce jag
			imageEl.onload = () => {
				const canvas = document.createElement('canvas');
				const canvas2 = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const ctx2 = canvas2.getContext('2d');
				const ratio = imageEl.width / imageEl.height;

				//first reduce by 1/2
				canvas.height = imageEl.height / 2;
				canvas.width = (imageEl.height / 2) * ratio;

				//then reduce to 256px
				canvas2.height = 156;
				canvas2.width = canvas2.height * ratio;

				//paint the first image
				ctx?.drawImage(imageEl, 0, 0, canvas.width, canvas.height);

				//paint the second image
				ctx2?.drawImage(canvas, 0, 0, canvas2.width, canvas2.height);

				//send up frame from second canvas
				const frame = canvas2.toDataURL('image/jpeg', 0.8);
				resolve(dataURItoBlob(frame));
				imageEl.remove();
				canvas.remove();
				canvas2.remove();
			}
			imageEl.src = url;
		} catch (e) {
			reject(e);
		}
	});
}

function dataURItoBlob(dataURI: string) {
	// convert base64/URLEncoded data component to raw binary data held in a string
	let byteString;
	if (dataURI.split(',')[0].indexOf('base64') >= 0)
		byteString = atob(dataURI.split(',')[1]);
	else
		byteString = unescape(dataURI.split(',')[1]);

	// separate out the mime component
	let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	// write the bytes of the string to a typed array
	const ia = new Uint8Array(byteString.length);
	for (var i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	return new Blob([ia], { type: mimeString });
}